import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getBooking, cancelBooking } from '../services/api';
//import { format } from 'date-fns';

function BookingConfirmation() {
  const { bookingId, merchantSlug } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const response = await getBooking(bookingId, merchantSlug);
        setBooking(response.data);
      } catch (error) {
        console.error('Error fetching booking:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBooking();
  }, [bookingId]);



  const handleCancel = async () => {
    if (window.confirm('確定要取消這個體驗嗎？')) {
      try {
        await cancelBooking(bookingId, merchantSlug);
        navigate('/bookings');
      } catch (error) {
        console.error('Error cancelling booking:', error);
        alert('取消體驗失敗');
      }
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-text-primary text-lg">載入中...</div>
      </div>
    );
  }

  if (!booking) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-text-primary text-lg">找不到體驗資訊</div>
      </div>
    );
  }

  return (
    <>
      {/* Status Banner */}
      <div className="flex flex-col items-center gap-4 p-6 bg-white dark:bg-background-dark rounded-xl shadow-sm">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-success/20">
          <span className="material-symbols-outlined text-success text-4xl">check_circle</span>
        </div>
        <div className="text-center">
          <p className="text-text-light dark:text-text-dark text-2xl font-bold leading-tight tracking-tight">
            體驗登記成功！
          </p>
          <p className="text-gray-500 dark:text-gray-400 text-sm font-normal leading-normal mt-1">
            我們已將體驗詳情發送至您的信箱。
          </p>
        </div>
      </div>

      {/* Information Card */}
      <div className="mt-6 bg-white dark:bg-background-dark rounded-xl shadow-sm p-6">
        <h3 className="text-text-light dark:text-text-dark font-bold text-lg mb-4">體驗詳情</h3>
        <div className="space-y-4">
          <div className="flex items-center border-t border-gray-200 dark:border-gray-700 pt-4">
            <span className="material-symbols-outlined text-gray-500 dark:text-gray-400 mr-3">
              home_repair_service
            </span>
            <div className="flex-1">
              <p className="text-gray-500 dark:text-gray-400 text-sm font-normal">服務項目</p>
              <p className="text-text-light dark:text-text-dark text-base font-semibold">
                {booking.service_name}
              </p>
            </div>
          </div>
          
          <div className="flex items-center border-t border-gray-200 dark:border-gray-700 pt-4">
            <span className="material-symbols-outlined text-gray-500 dark:text-gray-400 mr-3">
              calendar_month
            </span>
            <div className="flex-1">
              <p className="text-gray-500 dark:text-gray-400 text-sm font-normal">體驗日期</p>
              <p className="text-text-light dark:text-text-dark text-base font-semibold">
                {booking.booking_date}
              </p>
            </div>
          </div>
          
          <div className="flex items-center border-t border-gray-200 dark:border-gray-700 pt-4">
            <span className="material-symbols-outlined text-gray-500 dark:text-gray-400 mr-3">
              schedule
            </span>
            <div className="flex-1">
              <p className="text-gray-500 dark:text-gray-400 text-sm font-normal">體驗時間</p>
              <p className="text-text-light dark:text-text-dark text-base font-semibold">
                {booking.booking_time}
              </p>
            </div>
          </div>
          
          <div className="flex items-center border-t border-gray-200 dark:border-gray-700 pt-4">
            <span className="material-symbols-outlined text-gray-500 dark:text-gray-400 mr-3">
              person
            </span>
            <div className="flex-1">
              <p className="text-gray-500 dark:text-gray-400 text-sm font-normal">聯絡人姓名</p>
              <p className="text-text-light dark:text-text-dark text-base font-semibold">
                {booking.customer_name}
              </p>
            </div>
          </div>
          
          <div className="flex items-center border-t border-gray-200 dark:border-gray-700 pt-4">
            <span className="material-symbols-outlined text-gray-500 dark:text-gray-400 mr-3">
              phone
            </span>
            <div className="flex-1">
              <p className="text-gray-500 dark:text-gray-400 text-sm font-normal">聯絡電話</p>
              <p className="text-text-light dark:text-text-dark text-base font-semibold">
                {booking.customer_phone}
              </p>
            </div>
          </div>

          {booking.total_amount && (
            <div className="flex items-center border-t border-gray-200 dark:border-gray-700 pt-4">
              <span className="material-symbols-outlined text-gray-500 dark:text-gray-400 mr-3">
                payments
              </span>
              <div className="flex-1">
                <p className="text-gray-500 dark:text-gray-400 text-sm font-normal">費用</p>
                <p className="text-text-light dark:text-text-dark text-base font-semibold">
                  NT$ {booking.total_amount}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="mt-6 flex flex-col gap-3">
        {booking.status === 'pending' && (
          <Link
            to={`/payment/${booking.id}`}
            className="flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-5 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] transition-colors hover:bg-primary/90"
          >
            <span className="material-symbols-outlined mr-2">payment</span>
            <span className="truncate">立即付款</span>
          </Link>
        )}
        
        <Link
          to={`/booking/${booking.service}`}
          className="flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-5 bg-gray-200 dark:bg-gray-700 text-text-light dark:text-text-dark text-base font-bold leading-normal tracking-[0.015em] transition-colors hover:bg-gray-300 dark:hover:bg-gray-600"
        >
          <span className="truncate">修改體驗</span>
        </Link>
        
        {booking.status === 'pending' && (
          <button
            onClick={handleCancel}
            className="flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-5 bg-transparent text-danger text-base font-bold leading-normal tracking-[0.015em] transition-colors hover:bg-danger/10"
          >
            <span className="truncate">取消體驗</span>
          </button>
        )}
      </div>

      {/* Primary CTA Button */}
      <div className="mt-8 mb-4">
        <Link
          to="/bookings"
          className="flex w-full min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-14 px-5 bg-primary text-white text-lg font-bold leading-normal tracking-[0.015em] shadow-lg shadow-primary/30 transition-transform hover:scale-105"
        >
          <span className="truncate">查看所有體驗</span>
        </Link>
      </div>
    </>
  );
}

export default BookingConfirmation;